<template>
  <component :is="appLayout" />
</template>

<script>
import { mapGetters } from 'vuex';
import { defineAsyncComponent } from 'vue';
export default {
  name: 'Home',
  components: {
    Terminal: defineAsyncComponent(
      () => import(/* webpackChunkName: "terminal" */ './Terminal'),
    ),
    Web: defineAsyncComponent(
      () => import(/* webpackChunkName: "web" */ './Web'),
    ),
  },
  computed: {
    ...mapGetters(['isTerminalLayout']),
    appLayout() {
      if (this.isTerminalLayout) return 'Terminal';
      return 'Web';
    },
  },
};
</script>

<style lang="scss" scoped></style>
